import { AppSettingImplementation } from '@commoncore/implementation/AppSettingImplementation';

export class AppSettingController {
    public serviceUrl: String;
    public appSettingImplementation:AppSettingImplementation;
    public static singleInstance:any = null

    constructor(private globalService){
       this.appSettingImplementation = new AppSettingImplementation(globalService);
    }

    public static getInstance(globalService):AppSettingController{
		if(this.singleInstance == null){
			this.singleInstance = new AppSettingController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

    public async setAppSetting(dcGroupCode) {
        try{
            let resp = await this.appSettingImplementation.setAppSetting(dcGroupCode);
            return resp;
        }catch(err){
            console.log("error from settings API",err);
            return null;
        }
    }

    public populateAPIEndpointsInEnv() {
        return this.appSettingImplementation.populateAPIEndpointsInEnv();
    }

    public getAppSettingImplementation() {
        return this.appSettingImplementation;
    }
}